import { render, staticRenderFns } from "./c-alert.vue?vue&type=template&id=bc1c54ac&"
import script from "./c-alert.vue?vue&type=script&lang=js&"
export * from "./c-alert.vue?vue&type=script&lang=js&"
import style0 from "./c-alert.vue?vue&type=style&index=0&id=bc1c54ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports